<template>
  <div>
    <common-dialog ref="dialog" width="650px" show-save-button unit="设备维保记录" edit-title id-key="MaintenanceId"
      :data="data" :line-form="true" form-label-width="85px" :form-rules="rules" :save-func="api.save"
      @opened="onOpened" @create-opened="onCreateOpened" @edit-opened="onEditOpened" @closed="onClosed"
      @close-saved="$emit('close-saved')">
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备名称" prop="EquipmentName">
              <el-input v-model="data.EquipmentName" placeholder="请输入设备名称" @click.native="onManage" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备编号" prop="MaintenanceNo" class="notBottom">
              <span>{{ data.MaintenanceNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="维保内容" prop="MaintenanceRemarks">
              <el-input type="textarea" v-model="data.MaintenanceRemarks" placeholder="请输入维保内容" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维保类型" prop="MaintenanceType">
              <el-select v-model="data.MaintenanceType">
                <el-option value="保养"></el-option>
                <el-option value="维修" ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维修日期" prop="MaintenanceDate">
              <el-date-picker v-model="data.MaintenanceDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维保单位">
              <el-input v-model="data.MaintenanceUnit" placeholder="请输入维保单位" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="维保部门">
              <!-- <el-input v-model="data.DpName" placeholder="请输入维保部门" /> -->
              <tree-select ref="dpTreeSelect" :props="DpProps" :options="DpTreeData" :value="data.DpId"
                :clearable="false" :accordion="true" :parentSelect="true" placeholder="请选择"
                @node-select="onDpTreeSelect($event)" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划时间">
              <el-date-picker v-model="data.PlanDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="时间单位">
              <el-select v-model="data.Unit">
                <el-option value="小时" label="小时"></el-option>
                <el-option value="天" label="天"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开始日期">
              <el-date-picker v-model="data.StartDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束日期">
              <el-date-picker v-model="data.EndDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="费用">
              <el-input type="number" v-int v-model="data.Cost" placeholder="请输入费用" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="责任人">
              <el-input v-model="data.LiableEmpName" placeholder="请输入责任人" @click.native="onEmp('Liable')" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="验收人">
              <el-input v-model="data.ReceiverEmpName" @click.native="onEmp('Receiver')" placeholder="请输入验收人" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="制单人">
              <el-input v-model="data.AddUserName" @click.native="onEmp('User')" placeholder="请输入制单人" />
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <emp-select ref="empSelect" in-dialog selectable @select="setEmp"></emp-select>
    <manage-select ref="manageSelect" in-dialog selectable @select="setManage"></manage-select>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import empSelect from "@/components/personnel/result/record/listDialog.vue";
import manageSelect from "@/components/facility/manage/listDialog.vue";
import treeSelect from "@/components/common/treeSelect";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    empSelect,
    manageSelect,
    treeSelect
  },
  data() {
    return {
      data: {
        MaintenanceId: 0,
        EquipmentId: null,
        EquipmentName: "",
        EquipmentNo: "",
        DpName: "",
        DpId: null,
        Cost: null,
        MaintenanceNo: null,
        MaintenanceRemarks: "",
        MaintenanceType: null,
        MaintenanceDate: null,
        MaintenanceUnit: null,
        PlanDate: null,
        Unit: null,
        StartDate: null,
        EndDate: null,
        LiableEmpId: null,
        LiableEmpName: null,
        ReceiverEmpId: null,
        ReceiverEmpName: null,
        AddUserId: null,
        AddUserName: this.$commonJs.userName(),
      },
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/maintenance").default,
      dpApi: require("@/api/ent/dp").default,
      showList: [],
      empType: null,
      rules: {
        EquipmentName: [{ required: true, message: "设备名称不能为空" }],
        MaintenanceNo: [{ required: true, message: "设备编号不能为空" }],
        MaintenanceRemarks: [{ required: true, message: "维保内容不能为空" }],
        MaintenanceType: [{ required: true, message: "维保类型不能为空" }],
        MaintenanceDate: [{ required: true, message: "维修日期不能为空" }],
      },
      DpTreeData: [],
      DpProps: {
        value: "DpId",
        label: "DpName",
        children: "children",
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash
        ? this.urlHash.split("/").join("")
        : location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });

    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    onCreateOpened() {
      this.dpApi.list({}).then(res => this.DpTreeData = this.$commonJs.toTreeData(res.Data, 'DpId'))
    },
    onEditOpened(data) {
      this.api.info(data.MaintenanceId).then(res => {
        if (res.Code === 0) {
         
          this.data = { ...res.Data }
          // 部门
          this.dpApi.list({}).then((res) => {
            if (res.Code === 0) {
              this.DpTreeData = this.$commonJs.toTreeData(res.Data, 'DpId')
              this.$refs.dpTreeSelect.setData(this.data.DpId);
            }

          })
        }
      })
    },
    onManage() {
      this.$refs.manageSelect.open().then(that => {
        that.getData();
      });
    },
    setManage(data) {
      this.data.EquipmentName = data.EquipmentName;
      this.data.EquipmentId = data.EquipmentId;
      this.data.MaintenanceNo = data.EquipmentNo;
    },
    onEmp(type) {
      this.empType = type;
      this.$refs.empSelect.open();
    },
    setEmp(data) {
      console.log("data", data);
      if (this.empType == "Liable") {
        this.data.LiableEmpName = data.EmpName;
        this.data.LiableEmpId = data.EmpId;
      }
      if (this.empType == "Receiver") {
        this.data.ReceiverEmpName = data.EmpName;
        this.data.ReceiverEmpId = data.EmpId;
      }
      if (this.empType == "User") {
        this.data.AddUserName = data.EmpName;
        this.data.AddUserId = data.EmpId;
      }
    },
    onDpTreeSelect(t) {
      this.data.DpName = !t ? "" : t.DpName;
      this.data.DpId = !t ? null : t.DpId;
    },
    onClosed() {
      this.showList = [];
      this.$refs.dpTreeSelect.clearHandle()
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .notBottom .el-form-item__content {
  border-bottom: none;
}
</style>
